import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
class About extends React.Component {
  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }

  render() {
    const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>About LA Language Academy | Expert PTE & NAATI Preparation</title>
          <meta name="description" content="Learn about LA Language Academy, your trusted partner for PTE and NAATI exam preparation. Discover our mission, values & expert team dedicated to your success." />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://www.languageacademy.com.au/about`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@languageacademy" />
          <meta name="twitter:title" content="About LA Language Academy | Expert PTE & NAATI Preparation" />
          <meta name="twitter:description" content="Learn about LA Language Academy, your trusted partner for PTE and NAATI exam preparation. Discover our mission, values & expert team dedicated to your success." />
          <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta name="twitter:image:alt" content="LA Language Academy Logo" />
          <meta property="og:url" content={`https://www.languageacademy.com.au/about`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="About LA Language Academy | Expert PTE & NAATI Preparation" />
          <meta property="og:description" content="Learn about LA Language Academy, your trusted partner for PTE and NAATI exam preparation. Discover our mission, values & expert team dedicated to your success." />
          <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta property="og:image:alt" content="LA Language Academy Logo" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </Helmet>
        <Header />
        <div className="banner-section noc-banner">
          <div className="container">
            <div className="row">
              <div className="banner-content">
                <h1 className="primary-heading dark-blue-color">
                  AUSTRALIA'S LEADING ENGLISH
                  <br className="d-none d-md-block" />
                  PROFICIENCY & IMMIGRATION TEST
                  <br className="d-none d-md-block" />
                  PREPARATION CENTRE
                </h1>
                <p className="sub-title">
                  Helping 50,000+ students achieve their dreams through{" "}
                  <br className="d-none d-md-block" /> expert coaching and
                  proven results
                </p>
                <div className="iframe-video-outer position-relative">
                  <div className="banner-img-wrapper">
                    <img
                      className="banner-img"
                      src="/images/web-new-images/banners/about-banner.png"
                      alt="LA"
                    />
                  </div>
                  <img
                    className="emoji1 position-absolute"
                    src="/images/web-new-images/emojis/hand-emoji.png"
                    alt="LA"
                  />
                  <img
                    className="emoji2 position-absolute"
                    src="/images/web-new-images/emojis/emoji-2.png"
                    alt="LA"
                  />
                  <img
                    className="emoji3 position-absolute"
                    src="/images/web-new-images/emojis/smile-icon11.png"
                    alt="LA"
                  />
                  <img
                    className="emoji4 position-absolute"
                    src="/images/web-new-images/emojis/emoji-4.png"
                    alt="LA"
                  />
                </div>
                <ul className="banner-badge">
                  <li className="badge-list">7+ Years Experience</li>
                  <li className="badge-list">50,000+ Students</li>
                  <li className="badge-list">12+ Global Locations</li>
                  <li className="badge-list">95% Success Rate</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="noc-ccl-exam about-ourstory">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <h2 className="primary-heading text-center fw-700">
                  <span className="wpl-badge pte-naati-badge text-white">
                    OUR STORY
                  </span>
                  <br className="d-block" />
                  TRANSFORMING LIVES THROUGH <br className="d-none d-md-block" /> LANGUAGE MASTERY
                </h2>
              </div>
              <div className="col-md-6">
                <div className="ccl-exam-img">
                  <img
                    src="/images/web-new-images/about-img.png"
                    alt="Register Now"
                  />
                </div>
              </div>
              <div className="col-md-6 about-ourstory-content">
                <p>
                  Founded with a simple yet powerful vision: to help students
                  master the systems behind English proficiency tests, not just
                  the language itself.
                  <br />
                  <br />
                  What started as a single classroom has grown into Australia's
                  most trusted test preparation network, with 12+ branches
                  across Australia, India, and Nepal.
                  <br />
                  <br />
                  Over the past 7+ years, we've helped more than 50,000 students
                  achieve their immigration, education, and career goals.
                  <br />
                  <br />
                  We're not just another language school. We're the bridge
                  between your current abilities and your future success.
                </p>
              </div>
            </div>
            <div className="text-center mt-4 mt-md-0">
              <Link className="primary-btn" to="/auth/register">
                <span className="btn-inner">
                  DISCOVER OUR PROVEN APPROACH
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="home-about-la about-founder">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center text-white">
                <span className="wpl-badge gold-badge text-white">
                  MEET THE FOUNDER
                </span>
              </h2>
              <div>
                <div className="home-profile-row position-relative">
                  <div className="home-profile-card">
                    <div className="user-info">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/varun-img-01.png"
                          alt="Image"
                        />
                      </div>
                      <div className="user-content">
                        <h3 className="user-name">Varun Dhawan</h3>
                        <h3 className="user-designation">Founder</h3>
                      </div>
                    </div>
                  </div>
                  <img
                    className="d-none d-md-block home-profile-arrow position-absolute"
                    src="/images/web-new-images/shapes/bottom-arrow-01.png"
                    alt="Image"
                  />
                  <img
                    className="d-block d-md-none home-profile-arrow position-absolute"
                    src="/images/web-new-images/shapes/bottom-arrow-mobile-01.png"
                    alt="Image"
                  />
                </div>
                <div className="home-about-card">
                  <div className="card">
                    <div className="img-wrapper">
                      <svg
                        width="40"
                        height="38"
                        viewBox="0 0 40 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.6564 3.93697C19.0886 3.06146 19.3047 2.62371 19.598 2.48384C19.8532 2.36216 20.1498 2.36216 20.405 2.48384C20.6983 2.62371 20.9144 3.06146 21.3466 3.93697L25.4466 12.2432C25.5742 12.5016 25.638 12.6309 25.7312 12.7312C25.8137 12.8201 25.9127 12.892 26.0227 12.9432C26.1469 13.0009 26.2895 13.0218 26.5747 13.0635L35.7458 14.404C36.7116 14.5451 37.1945 14.6157 37.4179 14.8516C37.6124 15.0568 37.7038 15.3388 37.6668 15.6191C37.6242 15.9412 37.2747 16.2817 36.5755 16.9627L29.9417 23.424C29.7349 23.6255 29.6315 23.7262 29.5648 23.846C29.5057 23.9521 29.4678 24.0687 29.4532 24.1892C29.4367 24.3254 29.4611 24.4676 29.5099 24.7521L31.0751 33.8785C31.2402 34.841 31.3228 35.3223 31.1676 35.6079C31.0327 35.8564 30.7928 36.0307 30.5147 36.0823C30.1951 36.1415 29.7629 35.9142 28.8985 35.4596L20.6997 31.1479C20.4442 31.0136 20.3165 30.9464 20.1819 30.92C20.0628 30.8967 19.9402 30.8967 19.8211 30.92C19.6865 30.9464 19.5588 31.0136 19.3033 31.1479L11.1044 35.4596C10.2401 35.9142 9.80786 36.1415 9.48829 36.0823C9.21024 36.0307 8.97032 35.8564 8.83535 35.6079C8.68022 35.3223 8.76276 34.841 8.92785 33.8785L10.4931 24.7521C10.5419 24.4676 10.5663 24.3254 10.5498 24.1892C10.5352 24.0687 10.4973 23.9521 10.4382 23.846C10.3715 23.7262 10.2681 23.6255 10.0613 23.424L3.42751 16.9627C2.72833 16.2817 2.37874 15.9412 2.3362 15.6191C2.29919 15.3388 2.39063 15.0568 2.58506 14.8516C2.80853 14.6157 3.29141 14.5451 4.25717 14.404L13.4283 13.0635C13.7135 13.0218 13.8561 13.0009 13.9803 12.9432C14.0903 12.892 14.1893 12.8201 14.2718 12.7312C14.365 12.6309 14.4288 12.5016 14.5564 12.2432L18.6564 3.93697Z"
                          stroke="white"
                          strokeWidth="2.8125"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="card-content">
                      <h2>The Expert Who Cracked the Code</h2>
                      <p>
                        Varun Dhawan didn't just master the PTE exam, he
                        achieved a perfect 90 score 14 times. But his real
                        breakthrough came when he realized that most students
                        were solving the wrong problem.
                        <br />
                        <br />
                        After scoring perfect 90s in the PTE exam multiple
                        times, I realized there was a fundamental
                        misunderstanding about how these tests work. Language
                        Academy was built to bridge this gap, helping students
                        master the system, not just the language.
                      </p>
                    </div>
                  </div>
                  <div className="card">
                    <div className="img-wrapper">
                      <svg
                        width="46"
                        height="46"
                        viewBox="0 0 46 46"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.6875 37.9619H9.875C7.80393 37.9619 6.125 36.283 6.125 34.2119V7.96191C6.125 5.89085 7.80393 4.21191 9.875 4.21191H36.125C38.1961 4.21191 39.875 5.89085 39.875 7.96191V34.2119C39.875 36.283 38.1961 37.9619 36.125 37.9619H33.3125M23 36.0869C26.1066 36.0869 28.625 33.5685 28.625 30.4619C28.625 27.3553 26.1066 24.8369 23 24.8369C19.8934 24.8369 17.375 27.3553 17.375 30.4619C17.375 33.5685 19.8934 36.0869 23 36.0869ZM23 36.0869L23.0402 36.0865L17.0538 42.073L11.7505 36.7697L17.4118 31.1083M23 36.0869L28.9865 42.073L34.2898 36.7697L28.6284 31.1083M17.375 11.7119H28.625M13.625 18.2744H32.375"
                          stroke="white"
                          strokeWidth="2.8125"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="card-content">
                      <h4>Our Founder's Credentials</h4>
                      <ul className="circle-list">
                        <li>Perfect PTE scorer (90/90) achieved 14 times</li>
                        <li>
                          7+ years specializing in English test preparation
                        </li>
                        <li>500K+ YouTube subscribers trust his expertise</li>
                        <li>
                          Recognized authority in algorithm-based test
                          preparation
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row about-founder-bottom align-items-center">
              <div className="col-md-7">
                <div className="light-blue-box">
                  Today, Varun's methodology has become the gold standard for
                  test preparation, helping thousands of students achieve scores
                  they once thought were impossible.
                </div>
              </div>
              <div className="col-md-5">
                <div className="text-center text-md-end">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      LEARN FROM THE EXPERT{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="noc-why-choose why-most-section about-we-do">
          <div className="container">
            <div className="row why-most-second-row">
              <div className="col-lg-6 why-most-content">
                <h2 className="primary-heading fw-700">
                  <span className="wpl-badge text-white">WHAT WE DO</span>
                  <br />
                  FOUR PATHWAYS
                  <br />
                  TO SUCCESS
                </h2>
                <p className="sub-title">
                  We specialize in the tests that matter most for your future
                </p>
                <br />
                <div className="light-blue-box">
                  Secure 5 bonus points for Australian permanent residency
                  through our expert translation and interpretation training in
                  10 languages.
                </div>
                <br />
                <p className="sub-title fw-600">
                  Each program is built around the unique algorithm{" "}
                  <br className="d-none d-md-block" /> patterns that determine
                  success in that particular test.
                </p>
                <br />
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    EXPLORE OUR PROGRAMS
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
              </div>
              <div className="col-lg-6">
                <div className="why-most-list">
                  <ul>
                    <li className="list1">
                      <span className="list-counting">1</span>
                      <div>
                        <h3>PTE ACADEMIC</h3>
                        <p>
                          The globally recognized standard for university
                          admissions and visa applications. Our AI-powered
                          approach ensures you understand the 20+ question types
                          and integrated scoring system.
                        </p>
                      </div>
                    </li>
                    <li className="list2">
                      <span className="list-counting">2</span>
                      <div>
                        <h3>
                          <img
                            src="/images/web-new-images/flages/ca-flag.png"
                            alt="Register Now"
                          />{" "}
                          PTE CORE
                        </h3>
                        <p>
                          Specifically designed for Canadian immigration. Get
                          results in 24 hours vs. 13+ days for IELTS, with our
                          specialized Canadian pathway preparation.
                        </p>
                      </div>
                    </li>
                    <li className="list3">
                      <span className="list-counting">3</span>
                      <div>
                        <h3>IELTS</h3>
                        <p>
                          The traditional English proficiency test, perfected
                          through our systematic approach to band score
                          improvement and examiner expectations.
                        </p>
                      </div>
                    </li>
                    <li className="list4">
                      <span className="list-counting">4</span>
                      <div>
                        <h3>
                          <img
                            src="/images/web-new-images/flages/au-flag.png"
                            alt="Register Now"
                          />{" "}
                          NAATI CCL
                        </h3>
                        <p>
                          Secure 5 bonus points for Australian permanent
                          residency through our expert translation and
                          interpretation training in 10 languages.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="why-choosing-section poc-why-choosing">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center fw-700">
                <span className="wpl-badge gold-badge text-white">
                  OUR APPROACH
                </span>
                <br />
                SCIENCE MEETS SUCCESS
              </h2>
              <div className="feature-cards four-cards d-none d-md-grid">
                <div className="feature-card card2">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2.90918L14.012 8.14026C14.294 8.87349 14.435 9.24011 14.6542 9.54849C14.8486 9.8218 15.0874 10.0606 15.3607 10.2549C15.6691 10.4742 16.0357 10.6152 16.7689 10.8972L22 12.9092L16.7689 14.9211C16.0357 15.2031 15.6691 15.3442 15.3607 15.5634C15.0874 15.7578 14.8486 15.9966 14.6542 16.2699C14.435 16.5783 14.294 16.9449 14.012 17.6781L12 22.9092L9.98804 17.6781C9.70603 16.9449 9.56503 16.5782 9.34575 16.2699C9.15141 15.9966 8.91262 15.7578 8.63931 15.5634C8.33093 15.3442 7.96432 15.2031 7.23109 14.9211L2 12.9092L7.23108 10.8972C7.96431 10.6152 8.33093 10.4742 8.63931 10.2549C8.91262 10.0606 9.15141 9.8218 9.34575 9.54849C9.56503 9.24011 9.70603 8.87349 9.98804 8.14026L12 2.90918Z" stroke="#94C23C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </div>
                  <h3>AI-POWERED PRECISION</h3>
                  <p>
                    Our proprietary practice platform mirrors actual exam algorithms, providing the most accurate scoring system in the industry. Updated weekly to reflect the latest test changes.                    
                  </p>
                </div>
                <div className="feature-card card1">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 13.9092C12.6569 13.9092 14 12.566 14 10.9092C14 9.25233 12.6569 7.90918 11 7.90918C9.34315 7.90918 8 9.25233 8 10.9092C8 12.566 9.34315 13.9092 11 13.9092Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M17.7273 13.6365C17.6063 13.9106 17.5702 14.2148 17.6236 14.5097C17.6771 14.8046 17.8177 15.0767 18.0273 15.291L18.0818 15.3455C18.2509 15.5144 18.385 15.7149 18.4765 15.9357C18.568 16.1564 18.6151 16.393 18.6151 16.6319C18.6151 16.8708 18.568 17.1074 18.4765 17.3282C18.385 17.5489 18.2509 17.7494 18.0818 17.9183C17.913 18.0873 17.7124 18.2214 17.4917 18.3129C17.271 18.4044 17.0344 18.4515 16.7955 18.4515C16.5565 18.4515 16.3199 18.4044 16.0992 18.3129C15.8785 18.2214 15.678 18.0873 15.5091 17.9183L15.4545 17.8637C15.2403 17.6541 14.9682 17.5136 14.6733 17.4601C14.3784 17.4066 14.0742 17.4427 13.8 17.5637C13.5311 17.679 13.3018 17.8703 13.1403 18.1142C12.9788 18.3581 12.8921 18.6439 12.8909 18.9365V19.091C12.8909 19.5732 12.6994 20.0357 12.3584 20.3766C12.0174 20.7176 11.5549 20.9092 11.0727 20.9092C10.5905 20.9092 10.1281 20.7176 9.78708 20.3766C9.4461 20.0357 9.25455 19.5732 9.25455 19.091V19.0092C9.24751 18.7083 9.15011 18.4164 8.97501 18.1716C8.79991 17.9268 8.55521 17.7403 8.27273 17.6365C7.99853 17.5154 7.69437 17.4793 7.39947 17.5328C7.10456 17.5863 6.83244 17.7269 6.61818 17.9365L6.56364 17.991C6.39478 18.16 6.19425 18.2942 5.97353 18.3857C5.7528 18.4772 5.51621 18.5242 5.27727 18.5242C5.03834 18.5242 4.80174 18.4772 4.58102 18.3857C4.36029 18.2942 4.15977 18.16 3.99091 17.991C3.82186 17.8221 3.68775 17.6216 3.59626 17.4009C3.50476 17.1802 3.45766 16.9436 3.45766 16.7046C3.45766 16.4657 3.50476 16.2291 3.59626 16.0084C3.68775 15.7877 3.82186 15.5871 3.99091 15.4183L4.04545 15.3637C4.25503 15.1495 4.39562 14.8773 4.4491 14.5824C4.50257 14.2875 4.46647 13.9834 4.34545 13.7092C4.23022 13.4403 4.03887 13.211 3.79497 13.0495C3.55107 12.8879 3.26526 12.8013 2.97273 12.8001H2.81818C2.33597 12.8001 1.87351 12.6085 1.53253 12.2676C1.19156 11.9266 1 11.4641 1 10.9819C1 10.4997 1.19156 10.0372 1.53253 9.69626C1.87351 9.35528 2.33597 9.16372 2.81818 9.16372H2.9C3.2009 9.15669 3.49273 9.05929 3.73754 8.88419C3.98236 8.70909 4.16883 8.46439 4.27273 8.18191C4.39374 7.90771 4.42984 7.60355 4.37637 7.30864C4.3229 7.01374 4.18231 6.74162 3.97273 6.52736L3.91818 6.47282C3.74913 6.30396 3.61503 6.10343 3.52353 5.88271C3.43203 5.66198 3.38493 5.42539 3.38493 5.18645C3.38493 4.94752 3.43203 4.71092 3.52353 4.4902C3.61503 4.26947 3.74913 4.06895 3.91818 3.90009C4.08704 3.73104 4.28757 3.59693 4.50829 3.50543C4.72901 3.41394 4.96561 3.36684 5.20455 3.36684C5.44348 3.36684 5.68008 3.41394 5.9008 3.50543C6.12152 3.59693 6.32205 3.73104 6.49091 3.90009L6.54545 3.95463C6.75971 4.16421 7.03183 4.3048 7.32674 4.35827C7.62164 4.41175 7.9258 4.37565 8.2 4.25463H8.27273C8.54161 4.1394 8.77093 3.94805 8.93245 3.70415C9.09397 3.46025 9.18065 3.17444 9.18182 2.88191V2.72736C9.18182 2.24515 9.37338 1.78269 9.71435 1.44171C10.0553 1.10074 10.5178 0.90918 11 0.90918C11.4822 0.90918 11.9447 1.10074 12.2856 1.44171C12.6266 1.78269 12.8182 2.24515 12.8182 2.72736V2.80918C12.8193 3.10171 12.906 3.38752 13.0676 3.63142C13.2291 3.87532 13.4584 4.06667 13.7273 4.18191C14.0015 4.30292 14.3056 4.33902 14.6005 4.28555C14.8954 4.23208 15.1676 4.09149 15.3818 3.88191L15.4364 3.82736C15.6052 3.65831 15.8057 3.52421 16.0265 3.43271C16.2472 3.34121 16.4838 3.29411 16.7227 3.29411C16.9617 3.29411 17.1983 3.34121 17.419 3.43271C17.6397 3.52421 17.8402 3.65831 18.0091 3.82736C18.1781 3.99622 18.3122 4.19675 18.4037 4.41747C18.4952 4.63819 18.5423 4.87479 18.5423 5.11373C18.5423 5.35266 18.4952 5.58926 18.4037 5.80998C18.3122 6.0307 18.1781 6.23123 18.0091 6.40009L17.9545 6.45463C17.745 6.66889 17.6044 6.94101 17.5509 7.23592C17.4974 7.53082 17.5335 7.83498 17.6545 8.10918V8.18191C17.7698 8.45079 17.9611 8.6801 18.205 8.84163C18.4489 9.00315 18.7347 9.08983 19.0273 9.091H19.1818C19.664 9.091 20.1265 9.28256 20.4675 9.62353C20.8084 9.96451 21 10.427 21 10.9092C21 11.3914 20.8084 11.8539 20.4675 12.1948C20.1265 12.5358 19.664 12.7274 19.1818 12.7274H19.1C18.8075 12.7285 18.5217 12.8152 18.2778 12.9767C18.0339 13.1383 17.8425 13.3676 17.7273 13.6365Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </div>
                  <h3>ALGORITHM MASTERY</h3>
                  <p>While others focus on "better English," we target the exact mechanics behind how these exams score responses. Understanding the system is the key to consistently high scores.</p>
                </div>
                <div className="feature-card card4">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 6.90918V12.9092L16 14.9092M22 12.9092C22 18.432 17.5228 22.9092 12 22.9092C6.47715 22.9092 2 18.432 2 12.9092C2 7.38633 6.47715 2.90918 12 2.90918C17.5228 2.90918 22 7.38633 22 12.9092Z" stroke="#FFB02C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </div>
                  <h3>REAL-TIME ADAPTATION</h3>
                  <p>
                    We're the first in the industry to respond to test updates, ensuring our strategies, materials, and mobile app are always in sync with current exam standards.
                  </p>
                </div>
                <div className="feature-card card3">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 3.17871V7.30925C14 7.8693 14 8.14933 14.109 8.36324C14.2049 8.5514 14.3578 8.70438 14.546 8.80026C14.7599 8.90925 15.0399 8.90925 15.6 8.90925H19.7305M14 17.9092H8M16 13.9092H8M20 10.8974V18.1092C20 19.7893 20 20.6294 19.673 21.2712C19.3854 21.8356 18.9265 22.2946 18.362 22.5822C17.7202 22.9092 16.8802 22.9092 15.2 22.9092H8.8C7.11984 22.9092 6.27976 22.9092 5.63803 22.5822C5.07354 22.2946 4.6146 21.8356 4.32698 21.2712C4 20.6294 4 19.7893 4 18.1092V7.70918C4 6.02902 4 5.18894 4.32698 4.54721C4.6146 3.98272 5.07354 3.52378 5.63803 3.23616C6.27976 2.90918 7.11984 2.90918 8.8 2.90918H12.0118C12.7455 2.90918 13.1124 2.90918 13.4577 2.99207C13.7638 3.06556 14.0564 3.18677 14.3249 3.35126C14.6276 3.53678 14.887 3.79621 15.4059 4.31507L18.5941 7.50329C19.113 8.02215 19.3724 8.28157 19.5579 8.58432C19.7224 8.85274 19.8436 9.14538 19.9171 9.45148C20 9.79675 20 10.1636 20 10.8974Z" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </div>
                  <h3>PERSONALIZED GUIDANCE</h3>
                  <p>Expert trainers provide 1-on-1 feedback tailored to your specific challenges. You're never just another number, you're a future success story.</p>
                </div>
              </div>

              {/* Mobile HTML */}
              <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                <Slider {...CardsSlider} className="feature-cards four-cards">
                  <div className="feature-card card2">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2.90918L14.012 8.14026C14.294 8.87349 14.435 9.24011 14.6542 9.54849C14.8486 9.8218 15.0874 10.0606 15.3607 10.2549C15.6691 10.4742 16.0357 10.6152 16.7689 10.8972L22 12.9092L16.7689 14.9211C16.0357 15.2031 15.6691 15.3442 15.3607 15.5634C15.0874 15.7578 14.8486 15.9966 14.6542 16.2699C14.435 16.5783 14.294 16.9449 14.012 17.6781L12 22.9092L9.98804 17.6781C9.70603 16.9449 9.56503 16.5782 9.34575 16.2699C9.15141 15.9966 8.91262 15.7578 8.63931 15.5634C8.33093 15.3442 7.96432 15.2031 7.23109 14.9211L2 12.9092L7.23108 10.8972C7.96431 10.6152 8.33093 10.4742 8.63931 10.2549C8.91262 10.0606 9.15141 9.8218 9.34575 9.54849C9.56503 9.24011 9.70603 8.87349 9.98804 8.14026L12 2.90918Z" stroke="#94C23C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <h3>AI-POWERED PRECISION</h3>
                    <p>
                      Our proprietary practice platform mirrors actual exam algorithms, providing the most accurate scoring system in the industry. Updated weekly to reflect the latest test changes.
                    </p>                    
                  </div>
                  <div className="feature-card card1">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 13.9092C12.6569 13.9092 14 12.566 14 10.9092C14 9.25233 12.6569 7.90918 11 7.90918C9.34315 7.90918 8 9.25233 8 10.9092C8 12.566 9.34315 13.9092 11 13.9092Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M17.7273 13.6365C17.6063 13.9106 17.5702 14.2148 17.6236 14.5097C17.6771 14.8046 17.8177 15.0767 18.0273 15.291L18.0818 15.3455C18.2509 15.5144 18.385 15.7149 18.4765 15.9357C18.568 16.1564 18.6151 16.393 18.6151 16.6319C18.6151 16.8708 18.568 17.1074 18.4765 17.3282C18.385 17.5489 18.2509 17.7494 18.0818 17.9183C17.913 18.0873 17.7124 18.2214 17.4917 18.3129C17.271 18.4044 17.0344 18.4515 16.7955 18.4515C16.5565 18.4515 16.3199 18.4044 16.0992 18.3129C15.8785 18.2214 15.678 18.0873 15.5091 17.9183L15.4545 17.8637C15.2403 17.6541 14.9682 17.5136 14.6733 17.4601C14.3784 17.4066 14.0742 17.4427 13.8 17.5637C13.5311 17.679 13.3018 17.8703 13.1403 18.1142C12.9788 18.3581 12.8921 18.6439 12.8909 18.9365V19.091C12.8909 19.5732 12.6994 20.0357 12.3584 20.3766C12.0174 20.7176 11.5549 20.9092 11.0727 20.9092C10.5905 20.9092 10.1281 20.7176 9.78708 20.3766C9.4461 20.0357 9.25455 19.5732 9.25455 19.091V19.0092C9.24751 18.7083 9.15011 18.4164 8.97501 18.1716C8.79991 17.9268 8.55521 17.7403 8.27273 17.6365C7.99853 17.5154 7.69437 17.4793 7.39947 17.5328C7.10456 17.5863 6.83244 17.7269 6.61818 17.9365L6.56364 17.991C6.39478 18.16 6.19425 18.2942 5.97353 18.3857C5.7528 18.4772 5.51621 18.5242 5.27727 18.5242C5.03834 18.5242 4.80174 18.4772 4.58102 18.3857C4.36029 18.2942 4.15977 18.16 3.99091 17.991C3.82186 17.8221 3.68775 17.6216 3.59626 17.4009C3.50476 17.1802 3.45766 16.9436 3.45766 16.7046C3.45766 16.4657 3.50476 16.2291 3.59626 16.0084C3.68775 15.7877 3.82186 15.5871 3.99091 15.4183L4.04545 15.3637C4.25503 15.1495 4.39562 14.8773 4.4491 14.5824C4.50257 14.2875 4.46647 13.9834 4.34545 13.7092C4.23022 13.4403 4.03887 13.211 3.79497 13.0495C3.55107 12.8879 3.26526 12.8013 2.97273 12.8001H2.81818C2.33597 12.8001 1.87351 12.6085 1.53253 12.2676C1.19156 11.9266 1 11.4641 1 10.9819C1 10.4997 1.19156 10.0372 1.53253 9.69626C1.87351 9.35528 2.33597 9.16372 2.81818 9.16372H2.9C3.2009 9.15669 3.49273 9.05929 3.73754 8.88419C3.98236 8.70909 4.16883 8.46439 4.27273 8.18191C4.39374 7.90771 4.42984 7.60355 4.37637 7.30864C4.3229 7.01374 4.18231 6.74162 3.97273 6.52736L3.91818 6.47282C3.74913 6.30396 3.61503 6.10343 3.52353 5.88271C3.43203 5.66198 3.38493 5.42539 3.38493 5.18645C3.38493 4.94752 3.43203 4.71092 3.52353 4.4902C3.61503 4.26947 3.74913 4.06895 3.91818 3.90009C4.08704 3.73104 4.28757 3.59693 4.50829 3.50543C4.72901 3.41394 4.96561 3.36684 5.20455 3.36684C5.44348 3.36684 5.68008 3.41394 5.9008 3.50543C6.12152 3.59693 6.32205 3.73104 6.49091 3.90009L6.54545 3.95463C6.75971 4.16421 7.03183 4.3048 7.32674 4.35827C7.62164 4.41175 7.9258 4.37565 8.2 4.25463H8.27273C8.54161 4.1394 8.77093 3.94805 8.93245 3.70415C9.09397 3.46025 9.18065 3.17444 9.18182 2.88191V2.72736C9.18182 2.24515 9.37338 1.78269 9.71435 1.44171C10.0553 1.10074 10.5178 0.90918 11 0.90918C11.4822 0.90918 11.9447 1.10074 12.2856 1.44171C12.6266 1.78269 12.8182 2.24515 12.8182 2.72736V2.80918C12.8193 3.10171 12.906 3.38752 13.0676 3.63142C13.2291 3.87532 13.4584 4.06667 13.7273 4.18191C14.0015 4.30292 14.3056 4.33902 14.6005 4.28555C14.8954 4.23208 15.1676 4.09149 15.3818 3.88191L15.4364 3.82736C15.6052 3.65831 15.8057 3.52421 16.0265 3.43271C16.2472 3.34121 16.4838 3.29411 16.7227 3.29411C16.9617 3.29411 17.1983 3.34121 17.419 3.43271C17.6397 3.52421 17.8402 3.65831 18.0091 3.82736C18.1781 3.99622 18.3122 4.19675 18.4037 4.41747C18.4952 4.63819 18.5423 4.87479 18.5423 5.11373C18.5423 5.35266 18.4952 5.58926 18.4037 5.80998C18.3122 6.0307 18.1781 6.23123 18.0091 6.40009L17.9545 6.45463C17.745 6.66889 17.6044 6.94101 17.5509 7.23592C17.4974 7.53082 17.5335 7.83498 17.6545 8.10918V8.18191C17.7698 8.45079 17.9611 8.6801 18.205 8.84163C18.4489 9.00315 18.7347 9.08983 19.0273 9.091H19.1818C19.664 9.091 20.1265 9.28256 20.4675 9.62353C20.8084 9.96451 21 10.427 21 10.9092C21 11.3914 20.8084 11.8539 20.4675 12.1948C20.1265 12.5358 19.664 12.7274 19.1818 12.7274H19.1C18.8075 12.7285 18.5217 12.8152 18.2778 12.9767C18.0339 13.1383 17.8425 13.3676 17.7273 13.6365Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>                        
                      </div>
                    </div>
                    <h3>ALGORITHM MASTERY</h3>
                    <p>While others focus on "better English," we target the exact mechanics behind how these exams score responses. Understanding the system is the key to consistently high scores.</p>
                  </div>
                  <div className="feature-card card4">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 6.90918V12.9092L16 14.9092M22 12.9092C22 18.432 17.5228 22.9092 12 22.9092C6.47715 22.9092 2 18.432 2 12.9092C2 7.38633 6.47715 2.90918 12 2.90918C17.5228 2.90918 22 7.38633 22 12.9092Z" stroke="#FFB02C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <h3>REAL-TIME ADAPTATION</h3>
                    <p>We're the first in the industry to respond to test updates, ensuring our strategies, materials, and mobile app are always in sync with current exam standards.</p>
                  </div>
                  <div className="feature-card card3">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 3.17871V7.30925C14 7.8693 14 8.14933 14.109 8.36324C14.2049 8.5514 14.3578 8.70438 14.546 8.80026C14.7599 8.90925 15.0399 8.90925 15.6 8.90925H19.7305M14 17.9092H8M16 13.9092H8M20 10.8974V18.1092C20 19.7893 20 20.6294 19.673 21.2712C19.3854 21.8356 18.9265 22.2946 18.362 22.5822C17.7202 22.9092 16.8802 22.9092 15.2 22.9092H8.8C7.11984 22.9092 6.27976 22.9092 5.63803 22.5822C5.07354 22.2946 4.6146 21.8356 4.32698 21.2712C4 20.6294 4 19.7893 4 18.1092V7.70918C4 6.02902 4 5.18894 4.32698 4.54721C4.6146 3.98272 5.07354 3.52378 5.63803 3.23616C6.27976 2.90918 7.11984 2.90918 8.8 2.90918H12.0118C12.7455 2.90918 13.1124 2.90918 13.4577 2.99207C13.7638 3.06556 14.0564 3.18677 14.3249 3.35126C14.6276 3.53678 14.887 3.79621 15.4059 4.31507L18.5941 7.50329C19.113 8.02215 19.3724 8.28157 19.5579 8.58432C19.7224 8.85274 19.8436 9.14538 19.9171 9.45148C20 9.79675 20 10.1636 20 10.8974Z" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <h3>PERSONALIZED GUIDANCE</h3>
                    <p>Expert trainers provide 1-on-1 feedback tailored to your specific challenges. You're never just another number, you're a future success story.</p>
                  </div>
                </Slider>
              </div>

              <div className="text-center">
                <Link to="/auth/register" className="primary-btn">
                  EXPERIENCE OUR METHODOLOGY
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>


        <div className="master-aspect-section about-proven-result">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center fw-700">
                <span className="wpl-badge pte-naati-badge text-white">
                  PROVEN RESULTS</span> <br className="d-block d-md-none" /> That speak               
                <br />
                FOR THEMSELVES
              </h2>
              <div className="master-cards">
                <div className="master-card">
                  <div className="img-wrapper">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 18.0879V12.0879C21 7.11733 16.9706 3.08789 12 3.08789C7.02944 3.08789 3 7.11733 3 12.0879V18.0879M5.5 21.0879C4.11929 21.0879 3 19.9686 3 18.5879V16.5879C3 15.2072 4.11929 14.0879 5.5 14.0879C6.88071 14.0879 8 15.2072 8 16.5879V18.5879C8 19.9686 6.88071 21.0879 5.5 21.0879ZM18.5 21.0879C17.1193 21.0879 16 19.9686 16 18.5879V16.5879C16 15.2072 17.1193 14.0879 18.5 14.0879C19.8807 14.0879 21 15.2072 21 16.5879V18.5879C21 19.9686 19.8807 21.0879 18.5 21.0879Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h2 className="card-title">OUR IMPRESSIVE STATISTICS</h2>
                  <ul>
                    <li>
                      <h4>
                        <span className="circle"></span> 95% Success Rate
                      </h4>
                      <p>Students achieve target scores within 2 attempts</p>
                    </li>
                    <li>
                      <h4>
                        <span className="circle"></span> 94.6% Success Rate for "Stuck" Students
                      </h4>
                      <p>
                        Even those who failed 3+ times succeed with our approach
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="circle"></span> 79.4% First-Time Success
                      </h4>
                      <p>
                        Get your required score on the very first try
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="circle"></span> 50,000+ Successful Students
                      </h4>
                      <p>
                        Across all programs over 7+ years
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="circle"></span> 17-Point Average Improvement
                      </h4>
                      <p>
                        Significant score gains in just 21 days
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-center text-md-start bottom-btn-wrapper">
                <p className="sub-heading ">
                  These aren't just numbers, they represent dreams achieved, <br /> families reunited, and futures unlocked.
                </p>
                <Link to="/auth/register" className="primary-btn">
                  JOIN OUR SUCCESS STORIES
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>


         <div className="choice-ielts about-why-student">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading dark-blue-color text-center fw-700">
                  WHY <br className="d-block d-md-none" /> <span className="wpl-badge text-white">
                    50,000+ STUDENTS
                  </span>{" "}
                  <br className="d-block" />TRUST LANGUAGE ACADEMY
                </h2>
                <div className="plan-cards d-none d-md-flex">
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>CERTIFIED EXPERTISE</h2>
                        <p>
                          All trainers are NAATI-accredited professionals who understand test requirements inside out.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>MOST ACCURATE TECHNOLOGY</h2>
                        <p>
                          Our AI scoring engine is reverse-engineered from analyzing thousands of real exam results.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>COMPREHENSIVE RESOURCES</h2>
                        <p>
                          8,000+ practice questions, mobile app with 2000+ vocabulary words, constantly updated prediction files.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>FLEXIBLE LEARNING OPTIONS</h2>
                        <p>
                          Choose from online coaching, campus classes, or hybrid approaches that fit your lifestyle.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>RESULTS-FOCUSED GUARANTEE</h2>
                        <p>
                          We don't offer money-back guarantees because we deliver results. Our track record speaks for itself.
                        </p>
                      </div>  
                    </div>
                  </div>
                </div>
                <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                  <Slider {...CardsSlider} className="plan-cards">
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>CERTIFIED EXPERTISE</h2>
                          <p>
                            All trainers are NAATI-accredited professionals who understand test requirements inside out.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>MOST ACCURATE TECHNOLOGY</h2>
                          <p>
                            Our AI scoring engine is reverse-engineered from analyzing thousands of real exam results.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>COMPREHENSIVE RESOURCES</h2>
                          <p>
                            8,000+ practice questions, mobile app with 2000+ vocabulary words, constantly updated prediction files.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>FLEXIBLE LEARNING OPTIONS</h2>
                          <p>
                           Choose from online coaching, campus classes, or hybrid approaches that fit your lifestyle.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>RESULTS-FOCUSED GUARANTEE</h2>
                          <p>
                            We don't offer money-back guarantees because we deliver results. Our track record speaks for itself.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
              <div className="row">                
                <div className="col-md-12 text-center">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      DISCOVER YOUR PERFECT PROGRAM
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>


        <div className="master-aspect-section about-trust-section">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center fw-700">
                RECOGNITION
                <br />
                & <span className="wpl-badge pte-naati-badge text-white">
                  Trust
                </span>
              </h2>            

              <div className="master-cards">
                <div className="master-card">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 18.71V12.71C21 7.7394 16.9706 3.70996 12 3.70996C7.02944 3.70996 3 7.7394 3 12.71V18.71M5.5 21.71C4.11929 21.71 3 20.5907 3 19.21V17.21C3 15.8292 4.11929 14.71 5.5 14.71C6.88071 14.71 8 15.8292 8 17.21V19.21C8 20.5907 6.88071 21.71 5.5 21.71ZM18.5 21.71C17.1193 21.71 16 20.5907 16 19.21V17.21C16 15.8292 17.1193 14.71 18.5 14.71C19.8807 14.71 21 15.8292 21 17.21V19.21C21 20.5907 19.8807 21.71 18.5 21.71Z"
                        stroke="#7F56D9"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title">TRUSTED BY LEADING <br /> INSTITUTIONS</h2>
                  <ul>
                    <li>
                      <p><span className="circle"></span> University of Sydney</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> University of Melbourne</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> RMIT University</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> University of Queensland</p>
                    </li>                    
                  </ul>
                </div>
                <div className="master-card card2">
                  <div className="img-wrapper">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.249 17.71H20.4229M13.249 17.71L11.3359 21.71M13.249 17.71L16.1142 11.719C16.3451 11.2362 16.4606 10.9949 16.6185 10.9186C16.7559 10.8522 16.916 10.8522 17.0534 10.9186C17.2113 10.9949 17.3268 11.2362 17.5576 11.719L20.4229 17.71M20.4229 17.71L22.3359 21.71M2.33594 5.70996H8.33594M8.33594 5.70996H11.8359M8.33594 5.70996V3.70996M11.8359 5.70996H14.3359M11.8359 5.70996C11.3398 8.66725 10.1885 11.3461 8.50149 13.5944M10.3359 14.71C9.72341 14.4348 9.09859 14.052 8.50149 13.5944M8.50149 13.5944C7.14896 12.5577 5.9387 11.1366 5.33594 9.70996M8.50149 13.5944C6.8968 15.7329 4.80737 17.4818 2.33594 18.71"
                        stroke="#94C23C"
                        strokeOpacity="0.98"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title">
                    FEATURED IN <br /> LEADING MEDIA
                  </h2>
                  <ul>
                    <li>
                      <p><span className="circle"></span> SBS Australia</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> Education Times</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> Migration Institute of Australia</p>
                    </li>                   
                  </ul>
                </div>
                <div className="master-card card3">
                  <div className="img-wrapper">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.6641 6.70996V12.71L16.6641 14.71M22.6641 12.71C22.6641 18.2328 18.1869 22.71 12.6641 22.71C7.14121 22.71 2.66406 18.2328 2.66406 12.71C2.66406 7.18711 7.14121 2.70996 12.6641 2.70996C18.1869 2.70996 22.6641 7.18711 22.6641 12.71Z"
                        stroke="#0286FF"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title">INDUSTRY <br /> RECOGNITION</h2>
                  <ul>
                    <li>
                      <p><span className="circle"></span> 500K+ YouTube subscribers</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> Featured in Australian and international media</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> Recognized as algorithm-based test preparation pioneers</p>
                    </li>                   
                  </ul>
                </div>
              </div>
              <div className="text-center bottom-btn-wrapper">
                <p className="sub-heading fw-600 text-center">
                  Your success is our reputation, and we've built ours on delivering results.
                </p>
              </div>
            </div>
          </div>
        </div>


        <div className="pte-campus about-campus">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 text-center">
                <h2 className="primary-heading">
                  READY TO ACHIEVE
                   <br />
                  <span className="wpl-badge text-white mb-4">
                    YOUR TARGET <br /> SCORE?
                  </span>
                </h2>
              </div>
              <div className="col-lg-6">
                <div className="pte-campus-list">
                  <img
                    src="/images/web-new-images/emojis/rocket-icon.png"
                    alt="Register Now"
                  />
                  <p className="sub-title fw-300">
                  <br />
                    Join the thousands of students who've transformed their futures with Language Academy. Whether you're aiming for university admission, permanent residency, or career advancement, we have the expertise and proven system to get you there.</p>
                  <br />
                  <p className="sub-title fw-500">Don't let another failed attempt delay your dreams. Master the system that others struggle to understand.</p>
                </div>
                <Link to="/auth/register" className="primary-btn">
                  BOOK YOUR FREE CONSULTATION TODAY
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
            <div className="downlaodnow-row">
              <div className="downlaodnow-content">
                <h2>PTE CORE</h2>
                <p>
                  Download our PTE PRACTICE App
                  <br />
                  from App Store and Play Store
                </p>
              </div>
              <div className="downlaodnow-img">
                <img
                  src="/images/web-new-images/welcome-img.png"
                  alt="Register Now"
                />
              </div>
              <div className="downlaodnow-third-col">
                <h3 className="downlaodnow-title">Download Now!</h3>
                <div className="downlaodnow-btns">
                  <a href="#" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a href="#" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        
        
      



        <Footer />
      </React.Fragment>
    );
  }
}
export default About;
